(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const activeLocale = (document.documentElement.lang || 'es').split('-')[0].toLowerCase();
  const uiTexts = {
    es: { world: 'Mundo __NAME__', zoomDialog: 'Imagen ampliada de respuesta', zoomClose: 'Cerrar imagen ampliada', zoomOpen: 'Ampliar imagen', reverting: 'Volviendo al pack anterior', revertingLead: 'Volviendo al pack anterior…', updating: 'ACTUALIZANDO…', showPassword: 'Mostrar contraseña', hidePassword: 'Ocultar contraseña', stickyGifts: '__COUNT__ regalos GRATIS' },
    en: { world: '__NAME__ world', zoomDialog: 'Enlarged answer image', zoomClose: 'Close enlarged image', zoomOpen: 'Enlarge image', reverting: 'Returning to your previous pack', revertingLead: 'Returning to your previous pack…', updating: 'UPDATING…', showPassword: 'Show password', hidePassword: 'Hide password', stickyGifts: '__COUNT__ FREE gifts' },
    de: { world: 'Welt __NAME__', zoomDialog: 'Vergrößertes Antwortbild', zoomClose: 'Vergrößertes Bild schließen', zoomOpen: 'Bild vergrößern', reverting: 'Zurück zum vorherigen Set', revertingLead: 'Zurück zum vorherigen Set …', updating: 'WIRD AKTUALISIERT…', showPassword: 'Passwort anzeigen', hidePassword: 'Passwort verbergen', stickyGifts: '__COUNT__ GRATIS-Geschenke' }
  };
  const ui = uiTexts[activeLocale] || uiTexts.es;
  const numberLocale = ({ es: 'es-ES', en: 'en-US', de: 'de-DE' })[activeLocale] || 'es-ES';
  const copyRows = [
    ['Se queda encendido toda la noche', 'Stays on all night', 'Bleibt die ganze Nacht eingeschaltet'],
    ['Su luz acompaña toda la noche, sin apagados inesperados.', 'Its light stays with you all night, without switching off unexpectedly.', 'Das Licht begleitet euch die ganze Nacht, ohne unerwartet auszugehen.'],
    ['Motor silencioso', 'Quiet motor', 'Leiser Motor'],
    ['El movimiento acompaña la proyección sin añadir ruido a la habitación.', 'The movement adds to the projection without making the room noisy.', 'Die Bewegung ergänzt die Projektion, ohne den Raum mit Geräuschen zu stören.'],
    ['Luz suave y regulable', 'Soft, adjustable light', 'Sanftes, regulierbares Licht'],
    ['Ajusta la intensidad para crear el ambiente que mejor acompaña cada noche.', 'Adjust the brightness to create the right atmosphere for every night.', 'Passe die Helligkeit an und schaffe die passende Atmosphäre für jede Nacht.'],
    ['Mundos intercambiables', 'Interchangeable worlds', 'Austauschbare Welten'],
    ['Cambia de ficha y transforma el techo en una historia nueva.', 'Swap the slide and turn the ceiling into a new story.', 'Wechsle die Scheibe und verwandle die Decke in eine neue Geschichte.'],
    ['Sin instalación', 'No installation needed', 'Keine Installation nötig'],
    ['Enchúfalo por USB, coloca una ficha y enciéndelo: listo en segundos.', 'Plug it in via USB, insert a slide and switch it on: ready in seconds.', 'Per USB anschließen, eine Scheibe einsetzen und einschalten – in Sekunden startklar.'],
    ['EXPERIENCIAS REALES', 'REAL-LIFE EXPERIENCES', 'ECHTE ERFAHRUNGEN'],
    ['Galix en hogares reales', 'GALIX in real homes', 'GALIX in echten Familien zuhause'],
    ['Familias que ya duermen distinto', 'Families sleeping better already', 'Familien, die schon besser schlafen'],
    ['Una mirada de cerca al producto, sus fichas y la experiencia de uso.', 'A closer look at the product, its slides and the experience of using it.', 'Ein genauerer Blick auf das Produkt, seine Scheiben und die Nutzungserfahrung.'],
    ['Fotos del producto y reseñas verificadas de quienes ya disfrutan de GALIX.', 'Product photos and verified reviews from people who already enjoy GALIX.', 'Produktfotos und verifizierte Bewertungen von Menschen, die GALIX bereits genießen.'],
    ['Compra verificada en Loox', 'Verified purchase on Loox', 'Verifizierter Kauf bei Loox'],
    ['Verificada en Loox · Traducción', 'Verified on Loox', 'Verifiziert auf Loox · Übersetzung'],
    ['Contenido pendiente — testimonio real de cliente, con nombre y foto verificados.', 'Coming soon — a real customer testimonial with a verified name and photo.', 'In Kürze — ein echtes Kundenstatement mit verifiziertem Namen und Foto.'],
    ['Pendiente de validar', 'Awaiting verification', 'Wird noch verifiziert'],
    ['Comprar Galix', 'Shop GALIX', 'GALIX kaufen'],
    ['El efecto aurora parece increíblemente real, como tener la aurora boreal sobre la cama.', 'The aurora effect looks incredibly real, like having the Northern Lights above the bed.', 'Der Polarlichteffekt wirkt unglaublich echt – als lägen die Nordlichter über dem Bett.'],
    ['Todo llegó perfectamente embalado. Las fichas son fáciles de cambiar y hay una gran variedad.', 'Everything arrived beautifully packaged. The slides are easy to swap and there is a great variety.', 'Alles kam perfekt verpackt an. Die Scheiben lassen sich leicht wechseln und die Auswahl ist groß.'],
    ['Lo compré para mi sobrino y le gustó tanto que acabé pidiendo uno para mí.', 'I bought it for my nephew and he loved it so much that I ended up ordering one for myself.', 'Ich habe es für meinen Neffen gekauft. Es gefiel ihm so gut, dass ich schließlich auch eins für mich bestellt habe.'],
    ['Es compacto y aporta un ambiente muy acogedor a la habitación.', 'It is compact and gives the room a wonderfully cosy atmosphere.', 'Es ist kompakt und schafft eine sehr gemütliche Atmosphäre im Zimmer.'],
    ['La proyección de Saturno es increíble: parece tener un pequeño planetario en casa.', 'The Saturn projection is incredible: it feels like having a little planetarium at home.', 'Die Saturnprojektion ist unglaublich – wie ein kleines Planetarium zuhause.'],
    ['Es muy fácil de instalar y usar; las proyecciones se ven fantásticas.', 'It is very easy to set up and use; the projections look fantastic.', 'Es ist kinderleicht einzurichten und zu bedienen – die Projektionen sehen fantastisch aus.'],
    ['¿De verdad se va a ver como en los vídeos?', 'Will it really look like it does in the videos?', 'Sieht es wirklich so aus wie in den Videos?'],
    ['¿De verdad se ve como en los vídeos?', 'Will it really look like it does in the videos?', 'Sieht es wirklich so aus wie in den Videos?'],
    ['Sí. La proyección crea un efecto galaxia envolvente en techo y paredes. Para el mejor resultado, úsalo en una habitación a oscuras.', 'Yes. The projection creates an immersive galaxy across the ceiling and walls. For the best results, use it in a dark room.', 'Ja. Die Projektion erzeugt ein eindrucksvolles Galaxie-Erlebnis an Decke und Wänden. Am besten funktioniert sie in einem dunklen Raum.'],
    ['¿Es solo otro gadget más?', 'Is it just another gadget?', 'Ist es nur ein weiteres Gadget?'],
    ['¿Es solo otro gadget más? Ya he probado lucecitas y no funcionaron.', 'Is it just another gadget? We have already tried little lights and they did not work.', 'Ist es nur ein weiteres Gadget? Kleine Nachtlichter haben bei uns nicht funktioniert.'],
    ['GALIX está pensado para formar parte de una rutina nocturna sencilla y transformar el ambiente de la habitación.', 'GALIX is designed to become part of a simple bedtime routine and transform the atmosphere in the room.', 'GALIX ist als Teil einer einfachen Abendroutine gedacht und verwandelt die Atmosphäre im Zimmer.'],
    ['GALIX no es una luz fija: sus fichas intercambiables proyectan distintos mundos sobre el techo y las paredes para acompañar vuestra rutina antes de dormir.', 'GALIX is not a fixed light: its interchangeable slides project different worlds across the ceiling and walls to accompany your bedtime routine.', 'GALIX ist kein festes Nachtlicht: Die wechselbaren Scheiben projizieren verschiedene Welten an Decke und Wände und begleiten eure Abendroutine.'],
    ['¿Puede sobreestimular en lugar de calmar?', 'Could it overstimulate instead of calming?', 'Kann es statt zu beruhigen überreizen?'],
    ['¿No lo va a sobreestimular en vez de calmarlo?', 'Could it overstimulate them instead of calming them?', 'Könnte es eher überreizen als beruhigen?'],
    ['La intensidad se puede regular para adaptar la proyección al ambiente y a cada momento de la rutina.', 'The brightness is adjustable, so you can tailor the projection to the room and each moment of your routine.', 'Die Helligkeit lässt sich anpassen, damit Projektion und Atmosphäre zu jedem Moment eurer Routine passen.'],
    ['Está diseñado justo para lo contrario. La luz es tenue, el movimiento es lento y no hay sonidos ni pantallas.', 'It is designed to do the opposite. The light is gentle, the movement is slow, and there are no sounds or screens.', 'Es ist genau für das Gegenteil gedacht: sanftes Licht, langsame Bewegung und keine Geräusche oder Bildschirme.'],
    ['¿Puede quedarse encendido toda la noche?', 'Can it stay on all night?', 'Kann es die ganze Nacht eingeschaltet bleiben?'],
    ['¿Es seguro dejarlo encendido toda la noche? ¿Se apaga solo?', 'Is it safe to leave it on all night? Does it switch off by itself?', 'Kann es sicher die ganze Nacht eingeschaltet bleiben? Schaltet es sich von selbst aus?'],
    ['Puedes dejarlo encendido toda la noche. Funciona con corriente USB de bajo voltaje y no se calienta. Y a diferencia de otros proyectores, GALIX no se apaga solo a mitad de la noche.', 'You can leave it on all night. It runs on low-voltage USB power and does not heat up. Unlike other projectors, GALIX will not switch itself off in the middle of the night.', 'Du kannst es die ganze Nacht eingeschaltet lassen. Es wird über USB mit Niederspannung betrieben und erhitzt sich nicht. Anders als andere Projektoren schaltet sich GALIX nachts nicht von selbst aus.'],
    ['Hace ruido al girar?', 'Does it make noise while rotating?', 'Macht es beim Drehen Geräusche?'],
    ['¿Hace ruido al girar?', 'Does it make noise while rotating?', 'Macht es beim Drehen Geräusche?'],
    ['No. El motor es silencioso. Puede estar en marcha toda la noche sin que se oiga nada.', 'No. The motor is quiet, so it can run all night without disturbing the room.', 'Nein. Der Motor ist leise und kann die ganze Nacht laufen, ohne dass man ihn hört.'],
    ['¿Sirve también para adultos?', 'Is it suitable for adults too?', 'Ist es auch für Erwachsene geeignet?'],
    ['Sí. Mucha gente lo usa para desconectar después de un día estresante. La luz ayuda a bajar el ritmo antes de dormir.', 'Yes. Many people use it to unwind after a stressful day. The light helps them slow down before bed.', 'Ja. Viele nutzen es, um nach einem stressigen Tag abzuschalten. Das Licht hilft, vor dem Schlafengehen zur Ruhe zu kommen.'],
    ['¿Cómo funciona? ¿Necesito instalar algo?', 'How does it work? Do I need to install anything?', 'Wie funktioniert es? Muss ich etwas installieren?'],
    ['Nada. Lo enchufas a cualquier puerto USB, eliges la ficha y giras la parte superior para enfocar. Listo en menos de un minuto.', 'Nothing to install. Plug it into any USB port, choose a slide and turn the top to focus. Ready in under a minute.', 'Nichts. Einfach an einen USB-Anschluss anschließen, eine Scheibe auswählen und zum Fokussieren den oberen Teil drehen. In weniger als einer Minute startklar.'],
    ['¿Y si no funciona con mi hijo?', 'What if it does not work for my child?', 'Was, wenn es meinem Kind nicht gefällt?'],
    ['¿Y si GALIX no funciona con mi hijo?', 'What if GALIX does not work for my child?', 'Was, wenn GALIX meinem Kind nicht gefällt?'],
    ['Cada niño tiene sus preferencias. Podéis probar distintos mundos y ajustar la luz a vuestra rutina. Si no es para vosotros, consulta las condiciones de devolución de 90 días.', 'Every child is different. Try different worlds and adjust the light to your routine. If it is not right for you, see our 90-day return policy.', 'Jedes Kind ist anders. Probiert verschiedene Welten aus und passt das Licht an eure Routine an. Wenn GALIX nicht zu euch passt, informiert euch über unser 90-tägiges Rückgaberecht.'],
    ['¿Cuánto tarda el envío?', 'How long does shipping take?', 'Wie lange dauert der Versand?'],
    ['El pedido se prepara en 1–3 días laborables. La entrega estimada es de 5–10 días laborables en Estados Unidos y la Unión Europea.', 'Orders are prepared within 1–3 business days. Estimated delivery is 5–10 business days in the United States and the European Union.', 'Bestellungen werden innerhalb von 1–3 Werktagen bearbeitet. Die voraussichtliche Lieferzeit beträgt 5–10 Werktage in den USA und der Europäischen Union.'],
    ['El pedido se prepara en 1–3 días laborables. La entrega estimada es de 5–10 días laborables en Estados Unidos y la Unión Europea, con seguimiento del envío.', 'Orders are prepared within 1–3 business days. Estimated delivery is 5–10 business days in the United States and the European Union, with tracking included.', 'Bestellungen werden innerhalb von 1–3 Werktagen bearbeitet. Die voraussichtliche Lieferzeit beträgt 5–10 Werktage in den USA und der Europäischen Union. Eine Sendungsverfolgung ist inklusive.'],
    ['¿Cómo puedo seguir mi pedido?', 'How can I track my order?', 'Wie kann ich meine Bestellung verfolgen?'],
    ['Cuando el pedido salga recibirás un correo con el seguimiento. También puedes usar el número de pedido y el correo de compra en la página Localiza tu pedido.', 'Once your order ships, you will receive an email with tracking details. You can also use your order number and email address on the Track your order page.', 'Sobald deine Bestellung versandt wurde, erhältst du eine E-Mail mit der Sendungsverfolgung. Du kannst außerdem auf der Seite „Bestellung verfolgen“ deine Bestellnummer und E-Mail-Adresse eingeben.'],
    ['Cuando el pedido salga recibirás un correo con el seguimiento. También puedes consultar su estado en la página Localiza tu pedido.', 'Once your order ships, you will receive an email with tracking details. You can also check its status on the Track your order page.', 'Sobald deine Bestellung versandt wurde, erhältst du eine E-Mail mit der Sendungsverfolgung. Den Status kannst du auch auf der Seite „Bestellung verfolgen“ prüfen.'],
    ['¿Hacéis envíos internacionales?', 'Do you ship internationally?', 'Versendet ihr international?'],
    ['Sí. GALIX se envía internacionalmente. El plazo estimado y las condiciones disponibles para tu destino se muestran durante la compra.', 'Yes. GALIX ships internationally. Estimated delivery times and terms for your destination are shown at checkout.', 'Ja. GALIX wird international versandt. Die voraussichtliche Lieferzeit und die Bedingungen für dein Zielland werden beim Checkout angezeigt.'],
    ['Sí. GALIX se envía internacionalmente. El plazo estimado y las condiciones disponibles para tu destino se muestran durante el proceso de compra.', 'Yes. GALIX ships internationally. Estimated delivery times and terms for your destination are shown at checkout.', 'Ja. GALIX wird international versandt. Die voraussichtliche Lieferzeit und die Bedingungen für dein Zielland werden beim Checkout angezeigt.'],
    ['¿Puedo cambiar la dirección o cancelar el pedido?', 'Can I change the address or cancel my order?', 'Kann ich die Adresse ändern oder die Bestellung stornieren?'],
    ['Escríbenos cuanto antes con tu número de pedido. Si todavía no ha entrado en preparación intentaremos modificarlo; una vez preparado o enviado, el cambio no puede garantizarse.', 'Contact us as soon as possible with your order number. If preparation has not started, we will try to make the change. Once an order is being prepared or has shipped, changes cannot be guaranteed.', 'Melde dich so schnell wie möglich mit deiner Bestellnummer bei uns. Wenn die Bearbeitung noch nicht begonnen hat, versuchen wir die Änderung. Nach Beginn der Bearbeitung oder dem Versand können wir Änderungen nicht garantieren.'],
    ['Escríbenos cuanto antes con tu número de pedido. Si todavía no ha entrado en preparación intentaremos modificarlo; una vez preparado o enviado, el cambio ya no puede garantizarse.', 'Contact us as soon as possible with your order number. If preparation has not started, we will try to make the change. Once an order is being prepared or has shipped, changes cannot be guaranteed.', 'Melde dich so schnell wie möglich mit deiner Bestellnummer bei uns. Wenn die Bearbeitung noch nicht begonnen hat, versuchen wir die Änderung. Nach Beginn der Bearbeitung oder dem Versand können wir Änderungen nicht garantieren.'],
    ['¿Qué hago si llega dañado o con alguna pieza incorrecta?', 'What should I do if it arrives damaged or with a missing or incorrect part?', 'Was mache ich, wenn die Lieferung beschädigt ist oder ein Teil fehlt bzw. falsch ist?'],
    ['Contacta con nuestro equipo indicando el número de pedido y adjuntando fotografías del producto y del embalaje. Revisaremos el caso y te indicaremos la solución.', 'Contact our team with your order number and photos of the product and packaging. We will review the issue and let you know how we can help.', 'Kontaktiere unser Team mit deiner Bestellnummer und Fotos des Produkts und der Verpackung. Wir prüfen den Fall und teilen dir die passende Lösung mit.'],
    ['Contacta con nuestro equipo indicando el número de pedido y adjuntando fotografías del producto y del embalaje. Revisaremos el caso y te indicaremos la solución correspondiente.', 'Contact our team with your order number and photos of the product and packaging. We will review the issue and let you know how we can help.', 'Kontaktiere unser Team mit deiner Bestellnummer und Fotos des Produkts und der Verpackung. Wir prüfen den Fall und teilen dir die passende Lösung mit.'],
    ['¿Quién paga los gastos de devolución?', 'Who pays for return shipping?', 'Wer trägt die Rücksendekosten?'],
    ['Cuando la devolución no se debe a un defecto o daño, el envío de vuelta corre a cargo del cliente. Si ha llegado defectuoso o dañado, revisaremos el caso contigo.', 'If the return is not due to a defect or damage, return shipping is the customer’s responsibility. If it arrived faulty or damaged, we will review the case with you.', 'Wenn die Rückgabe nicht auf einen Defekt oder Schaden zurückgeht, trägt der Kunde die Rücksendekosten. Bei einem defekten oder beschädigten Artikel prüfen wir den Fall gemeinsam mit dir.'],
    ['Cuando la devolución no se debe a un defecto o daño, el envío de vuelta corre a cargo del cliente. Si el producto ha llegado defectuoso o dañado, nuestro equipo revisará el caso contigo.', 'If the return is not due to a defect or damage, return shipping is the customer’s responsibility. If the product arrived faulty or damaged, our team will review the case with you.', 'Wenn die Rückgabe nicht auf einen Defekt oder Schaden zurückgeht, trägt der Kunde die Rücksendekosten. Bei einem defekten oder beschädigten Produkt prüft unser Team den Fall gemeinsam mit dir.'],
    ['¿Cómo solicito una devolución?', 'How do I request a return?', 'Wie beantrage ich eine Rückgabe?'],
    ['Contacta con nuestro equipo dentro de los 90 días posteriores a la compra e indica tu número de pedido. Te enviaremos los pasos antes de que realices el envío.', 'Contact our team within 90 days of purchase and include your order number. We will send you the steps before you return the item.', 'Kontaktiere unser Team innerhalb von 90 Tagen nach dem Kauf und nenne deine Bestellnummer. Wir senden dir die Schritte, bevor du den Artikel zurückschickst.'],
    ['Contacta con nosotros dentro de los 90 días posteriores a la compra e indica tu número de pedido. Te enviaremos los pasos antes de que realices el envío.', 'Contact us within 90 days of purchase and include your order number. We will send you the steps before you return the item.', 'Kontaktiere uns innerhalb von 90 Tagen nach dem Kauf und nenne deine Bestellnummer. Wir senden dir die Schritte, bevor du den Artikel zurückschickst.'],
    ['Contacta con nosotros dentro de los 90 días posteriores a la compra e indica tu número de pedido. Te enviaremos los pasos y la dirección de devolución antes de que realices el envío.', 'Contact us within 90 days of purchase and include your order number. We will send you the return steps and address before you ship the item.', 'Kontaktiere uns innerhalb von 90 Tagen nach dem Kauf und nenne deine Bestellnummer. Wir senden dir die Rückgabeschritte und die Rücksendeadresse, bevor du den Artikel verschickst.'],
    ['Toca el proyector para apagar la luz', 'Tap the projector to turn the light off', 'Tippe auf den Projektor, um das Licht auszuschalten'],
    ['Pensado para que ambos', 'Made for both of you to', 'Damit ihr beide'],
    ['durmáis mejor', 'sleep better', 'besser schlaft'],
    ['Características confirmadas del producto', 'Verified product features', 'Bestätigte Produkteigenschaften'],
    ['POR QUÉ FUNCIONA', 'WHY IT WORKS', 'WARUM ES FUNKTIONIERT'],
    ['Proyector GALIX', 'GALIX projector', 'GALIX-Projektor'],
    ['Contenido del pack', 'Pack contents', 'Set-Inhalt'],
    ['Proyector', 'Projector', 'Projektor'],
    ['proyector', 'projector', 'Projektor'],
    ['fichas', 'slides', 'Scheiben'],
    ['Fichas', 'Slides', 'Scheiben'],
    ['mundos', 'worlds', 'Welten'],
    ['regalos', 'gifts', 'Geschenke'],
    ['Ahorras', 'You save', 'Du sparst'],
    ['GRATIS', 'FREE', 'GRATIS'],
    ['AÑADIR AL CARRITO', 'ADD TO CART', 'IN DEN WARENKORB'],
    ['AGOTADO', 'SOLD OUT', 'AUSVERKAUFT'],
    ['Este pack incluye', 'This pack includes', 'Dieses Set enthält'],
    ['Proyector y fichas intercambiables', 'Projector and interchangeable slides', 'Projektor und austauschbare Scheiben'],
    ['Guía Bedtime Calm', 'Bedtime Calm Guide', 'Bedtime-Calm-Guide'],
    ['Modo luz nocturna', 'Night-light mode', 'Nachtlichtmodus'],
    ['Ideas para la rutina de dormir.', 'Ideas for your bedtime routine.', 'Ideen für eure Abendroutine.'],
    ['Luz cálida integrada en GALIX.', 'Warm light built into GALIX.', 'Warmes Licht direkt in GALIX integriert.'],
    ['Pago único · Sin suscripción', 'One-time payment · No subscription', 'Einmalzahlung · Kein Abonnement'],
    ['VER EL PRODUCTO', 'VIEW THE PRODUCT', 'PRODUKT ANSEHEN'],
    ['MÁS ELEGIDO', 'MOST POPULAR', 'AM BELIEBTESTEN'],
    ['REGALO', 'GIFT', 'GESCHENK'],
    ['Ampliar ⤢', 'Zoom in ⤢', 'Vergrößern ⤢'],
    ['Prueba las fichas de este pack', 'Try the slides in this pack', 'Probiere die Scheiben dieses Sets aus'],
    ['Fotos del producto', 'Product photos', 'Produktfotos'],
    ['Contenido del pack seleccionado', 'Selected pack contents', 'Inhalt des ausgewählten Sets'],
    ['Selecciona un pack', 'Select a pack', 'Wähle ein Set'],
    ['Sobre el producto', 'About the product', 'Über das Produkt'],
    ['Compra/envío', 'Shopping/shipping', 'Bestellung/Versand'],
    ['Garantía/confianza', 'Guarantee/trust', 'Garantie/Vertrauen'],
    ['PARA COMPRAR CON CONFIANZA', 'SHOP WITH CONFIDENCE', 'MIT VERTRAUEN KAUFEN'],
    ['Resolviendo tus dudas,', 'Answering your questions,', 'Wir beantworten deine Fragen,'],
    ['antes de que las tengas', 'before you even have them', 'bevor sie überhaupt entstehen'],
    ['Así se ven los mundos de quienes ya tienen GALIX', 'See the worlds created by GALIX owners', 'So sehen die Welten von GALIX-Besitzern aus'],
    ['Fotos y opiniones compartidas por compradores de GALIX en Loox.', 'Photos and reviews shared by GALIX customers on Loox.', 'Fotos und Bewertungen von GALIX-Kunden auf Loox.'],
    ['Sus fotos', 'Their photos', 'Ihre Fotos'],
    ['Stock vendido', 'Stock sold', 'Verkaufter Bestand'],
    ['Fichas intercambiables', 'Interchangeable slides', 'Austauschbare Scheiben'],
    ['Variante seleccionada', 'Selected variant', 'Ausgewählte Variante'],
    ['Apagar proyector', 'Turn projector off', 'Projektor ausschalten'],
    ['Una mano sostiene una ficha intercambiable de GALIX', 'A hand holding an interchangeable GALIX slide', 'Eine Hand hält eine austauschbare GALIX-Scheibe'],
    ['Proyección GALIX en una habitación familiar', 'GALIX projection in a family bedroom', 'GALIX-Projektion in einem Familienzimmer'],
    ['Galería de imágenes de GALIX', 'GALIX image gallery', 'GALIX-Bildergalerie'],
    ['Cerrar galería', 'Close gallery', 'Galerie schließen'],
    ['Imagen anterior', 'Previous image', 'Vorheriges Bild'],
    ['Imagen siguiente', 'Next image', 'Nächstes Bild'],
    ['Miniaturas de la galería', 'Gallery thumbnails', 'Galerie-Miniaturen'],
    ['Añadir al carrito', 'Add to cart', 'In den Warenkorb'],
    ['Agotado', 'Sold out', 'Ausverkauft'],
    ['Añadir por', 'Add for', 'Hinzufügen für'],
    ['Elige tu pack', 'Choose your pack', 'Wähle dein Set'],
    ['Comprar ahora', 'Shop now', 'Jetzt kaufen'],
    ['REGALO', 'GIFT', 'GESCHENK'],
    ['¿De verdad se ve como en los vídeos?', 'Will it really look like it does in the videos?', 'Sieht es wirklich so aus wie in den Videos?'],
  ];
  const copy = new Map(copyRows.map(([source, en, de]) => [source, { en, de }]));
  const localizeText = (value) => {
    const text = String(value || '');
    const trimmed = text.trim();
    const direct = copy.get(trimmed);
    if (direct) return text.replace(trimmed, direct[activeLocale]);
    const quoted = trimmed.match(/^([“"'])(.*)([”"'])$/s);
    if (quoted && copy.has(quoted[2])) return text.replace(trimmed, `${quoted[1]}${copy.get(quoted[2])[activeLocale]}${quoted[3]}`);
    const worlds = trimmed.match(/^(Pack\s+)?(\d+)\s+mundos$/i);
    if (worlds) return text.replace(trimmed, `${worlds[1] ? (activeLocale === 'en' ? 'Pack of ' : 'Set mit ') : ''}${worlds[2]} ${activeLocale === 'en' ? 'worlds' : 'Welten'}`);
    const stickyPack = trimmed.match(/^Pack\s+(\d+)\s+mundos\s+·\s+(\d+)\s+regalos\s+GRATIS$/i);
    if (stickyPack) return text.replace(trimmed, `${activeLocale === 'en' ? 'Pack of ' : 'Set mit '}${stickyPack[1]} ${activeLocale === 'en' ? 'worlds' : 'Welten'} · ${stickyPack[2]} ${activeLocale === 'en' ? 'free gifts' : 'Gratisgeschenke'}`);
    const gifts = trimmed.match(/^\+?\s*(\d+)\s+regalos(\s+incluidos)?$/i);
    if (gifts) return text.replace(trimmed, `+ ${gifts[1]} ${activeLocale === 'en' ? 'gifts' : 'Geschenke'}${gifts[2] ? (activeLocale === 'en' ? ' included' : ' inklusive') : ''}`);
    const freeGifts = trimmed.match(/^(\d+)\s+regalos\s+GRATIS$/i);
    if (freeGifts) return text.replace(trimmed, `${freeGifts[1]} ${activeLocale === 'en' ? 'free gifts' : 'Gratisgeschenke'}`);
    const savings = trimmed.match(/^Ahorras\s+(.+?)(\s*€)(?:\s*\+\s*(\d+)\s+regalos)?$/i);
    if (savings) return text.replace(trimmed, `${activeLocale === 'en' ? 'You save ' : 'Du sparst '}${savings[1]}${savings[2]}${savings[3] ? ` + ${savings[3]} ${activeLocale === 'en' ? 'gifts' : 'Geschenke'}` : ''}`);
    return value;
  };
  function localizeStaticContent(root = document) {
    if (activeLocale !== 'en' && activeLocale !== 'de') return;
    const language = activeLocale;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script,style,noscript,textarea,[data-no-translate]')) return NodeFilter.FILTER_REJECT;
        return localizeText(node.nodeValue) !== node.nodeValue
          ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => { node.nodeValue = localizeText(node.nodeValue); });
    root.querySelectorAll?.('[placeholder],[aria-label],[title]').forEach((element) => {
      ['placeholder', 'aria-label', 'title'].forEach((attribute) => {
        if (element.hasAttribute(attribute)) element.setAttribute(attribute, localizeText(element.getAttribute(attribute)));
      });
    });
  }
  localizeStaticContent();
  const translationObserver = new MutationObserver((records) => {
    if (activeLocale !== 'en' && activeLocale !== 'de') return;
    records.forEach((record) => {
      if (record.type === 'characterData' && record.target.parentElement) {
        const translated = localizeText(record.target.nodeValue);
        if (translated !== record.target.nodeValue) record.target.nodeValue = translated;
      }
      record.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) localizeStaticContent(node);
        else if (node.nodeType === Node.TEXT_NODE && node.parentElement) node.nodeValue = localizeText(node.nodeValue);
      });
    });
  });
  if (activeLocale === 'en' || activeLocale === 'de') translationObserver.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  const localeRoot = window.Shopify?.routes?.root || '/';
  const localePath = (path) => `${localeRoot}${String(path).replace(/^\/+/, '')}`;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initGallery(scope = document) {
    const gallery = $('[data-gx-gallery]', scope);
    if (!gallery || gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const main = $('.gx-gallery__hero', gallery);
    if (!main) return;
    const thumbs = $$('[data-gx-gallery-thumb]', gallery);
    const thumbsContainer = $('.gx-gallery__grid', gallery);
    const previous = $('[data-gx-gallery-prev]', gallery);
    const next = $('[data-gx-gallery-next]', gallery);
    const openButton = $('[data-gx-gallery-open]', gallery);
    const lightbox = $('[data-gx-gallery-lightbox]', gallery);
    const lightboxImage = $('[data-gx-lightbox-image]', gallery);
    const lightboxCount = $('[data-gx-lightbox-count]', gallery);
    const lightboxPrevious = $('[data-gx-lightbox-prev]', gallery);
    const lightboxNext = $('[data-gx-lightbox-next]', gallery);
    const lightboxThumbs = $$('[data-gx-lightbox-thumb]', gallery);
    const lightboxClose = $('[data-gx-gallery-close]', gallery);
    const lightboxStage = $('[data-gx-gallery-stage]', gallery);
    let index = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    let opener = null;
    let dragStart = null;
    let mainDragStart = null;
    let mainTouchStart = null;
    let lastMainSwipeAt = -Infinity;
    const swipeMain = (startX, startY, endX, endY) => {
      if (performance.now() - lastMainSwipeAt < 300) return;
      const dx = endX - startX;
      const dy = endY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        lastMainSwipeAt = performance.now();
        select(index + (dx < 0 ? 1 : -1));
      }
    };
    let packSrc = '';
    // Foto del pack elegido (proyector + fichas). Se queda en la imagen principal hasta que se toque la galería.
    gallery._gxShowPack = (src, alt) => {
      if (!src) return;
      packSrc = src;
      main.src = src;
      main.srcset = '';
      main.alt = alt || main.alt;
      main.classList.add('is-pack');
      thumbs.forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-current', 'false'); });
      if (lightboxImage) { lightboxImage.src = src; lightboxImage.alt = main.alt; }
    };
    const select = (nextIndex) => {
      if (!thumbs.length) return;
      packSrc = '';
      main.classList.remove('is-pack');
      index = Math.max(0, Math.min(thumbs.length - 1, nextIndex));
      const thumb = thumbs[index];
      const image = $('img', thumb);
      if (!image) return;
      const src = thumb.dataset.fallbackImage || image.currentSrc || image.src;
      main.src = src;
      main.srcset = '';
      main.alt = image.alt;
      thumbs.forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', String(active));
      });
      if (thumbsContainer?.scrollWidth > thumbsContainer?.clientWidth + 1) {
        const trackRect = thumbsContainer.getBoundingClientRect();
        const thumbRect = thumb.getBoundingClientRect();
        thumbsContainer.scrollTo({
          left: thumbsContainer.scrollLeft + thumbRect.left - trackRect.left - (trackRect.width - thumbRect.width) / 2,
          behavior: reducedMotion ? 'instant' : 'smooth'
        });
      } else if (thumbsContainer?.scrollHeight > thumbsContainer?.clientHeight) {
        const trackRect = thumbsContainer.getBoundingClientRect();
        const thumbRect = thumb.getBoundingClientRect();
        thumbsContainer.scrollTo({
          top: thumbsContainer.scrollTop + thumbRect.top - trackRect.top - (trackRect.height - thumbRect.height) / 2,
          behavior: reducedMotion ? 'instant' : 'smooth'
        });
      }
      if (previous) previous.hidden = index === 0;
      if (next) next.hidden = index === thumbs.length - 1;
      if (lightboxImage) {
        lightboxImage.src = src;
        lightboxImage.alt = image.alt;
      }
      if (lightboxCount) lightboxCount.textContent = `${index + 1} / ${thumbs.length}`;
      if (lightboxPrevious) lightboxPrevious.hidden = index === 0;
      if (lightboxNext) lightboxNext.hidden = index === thumbs.length - 1;
      lightboxThumbs.forEach((item, itemIndex) => {
        const active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', String(active));
        if (active && lightbox?.open) item.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    };
    const open = (source) => {
      if (!lightbox || typeof lightbox.showModal !== 'function') return;
      opener = source;
      lightbox.showModal();
      document.documentElement.classList.add('gx-gallery-lightbox-open');
      if (packSrc && source === openButton) { if (lightboxImage) lightboxImage.src = packSrc; } else select(index);
      lightboxClose?.focus();
    };
    const close = () => { if (lightbox?.open) lightbox.close(); };
    openButton?.addEventListener('click', (event) => {
      if (performance.now() - lastMainSwipeAt < 350) {
        event.preventDefault();
        return;
      }
      open(openButton);
    });
    openButton?.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary) return;
      mainDragStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
    });
    openButton?.addEventListener('pointerup', (event) => {
      if (!mainDragStart || mainDragStart.id !== event.pointerId) return;
      swipeMain(mainDragStart.x, mainDragStart.y, event.clientX, event.clientY);
      mainDragStart = null;
    });
    openButton?.addEventListener('pointercancel', () => { mainDragStart = null; });
    openButton?.addEventListener('touchstart', (event) => {
      const touch = event.changedTouches[0];
      if (touch) mainTouchStart = { x: touch.clientX, y: touch.clientY };
    }, { passive: true });
    openButton?.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (mainTouchStart && touch) swipeMain(mainTouchStart.x, mainTouchStart.y, touch.clientX, touch.clientY);
      mainTouchStart = null;
    }, { passive: true });
    openButton?.addEventListener('touchcancel', () => { mainTouchStart = null; }, { passive: true });
    thumbs.forEach((thumb, thumbIndex) => thumb.addEventListener('click', () => {
      select(thumbIndex);
      if (!window.matchMedia('(max-width: 749px)').matches) open(thumb);
    }));
    previous?.addEventListener('click', () => select(index - 1));
    next?.addEventListener('click', () => select(index + 1));
    lightboxPrevious?.addEventListener('click', () => select(index - 1));
    lightboxNext?.addEventListener('click', () => select(index + 1));
    lightboxThumbs.forEach((thumb, thumbIndex) => thumb.addEventListener('click', () => select(thumbIndex)));
    lightboxClose?.addEventListener('click', close);
    lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) close(); });
    lightbox?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        select(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    lightbox?.addEventListener('close', () => {
      document.documentElement.classList.remove('gx-gallery-lightbox-open');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
      opener = null;
    });
    lightboxStage?.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || event.target.closest('button')) return;
      dragStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
    });
    lightboxStage?.addEventListener('pointerup', (event) => {
      if (!dragStart || dragStart.id !== event.pointerId) return;
      const dx = event.clientX - dragStart.x;
      const dy = event.clientY - dragStart.y;
      dragStart = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) select(index + (dx < 0 ? 1 : -1));
    });
    lightboxStage?.addEventListener('pointercancel', () => { dragStart = null; });
    gallery._gxGalleryCleanup = () => close();
  }

  function initVariants(scope = document) {
    const root = $('[data-gx-product]', scope);
    if (!root || root.dataset.variantReady) return;
    root.dataset.variantReady = 'true';
    const input = $('[data-gx-variant-input]', root);
    const buttonPrice = $('[data-gx-button-price]', root);
    const add = $('[data-gx-add]', root);
    const stickySelect = $('[data-gx-sticky-select]', root);
    const stickyPrice = $('[data-gx-sticky-price]', root);
    const stickyAdd = $('[data-gx-sticky-add]', root);
    const stickyAddLabel = $('[data-gx-sticky-add-label]', root);
    const stickyPack = $('[data-gx-sticky-pack]', root);
    const stickyDiscounts = $$('[data-gx-sticky-discount]', root);
    const stickyMobilePack = $('[data-gx-sticky-mobile-pack]', root);
    const stickyMobileAddLabel = $('[data-gx-sticky-mobile-add-label]', root);
    const stock = $('[data-gx-stock]', root);
    const gifts = $('[data-gx-pack-includes]', root);
    const giftsHeading = $('[data-gx-gifts-heading]', root);
    const productCopy = $('[data-gx-product-copy]', root)?.dataset || {};
    const productText = (template, count) => String(template || '').replace('__COUNT__', count);
    const options = $$('[data-gx-variant]', root);
    const quantity = $('[data-gx-quantity]', root);
    const clampQuantity = (value) => Math.min(99, Math.max(1, Number.isFinite(Number(value)) ? Math.floor(Number(value)) : 1));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const amountFormatter = new Intl.NumberFormat((window.Shopify?.currency?.active || 'EUR') === 'EUR' ? 'es-ES' : 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const setPrice = (element, value) => {
      if (!element || element.textContent === value) return;
      element.textContent = value;
      if (!reducedMotion.matches && typeof element.animate === 'function') {
        element.animate([{ opacity: .45, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
    };
    const updatePrices = () => {
      const option = options.find((item) => item.classList.contains('is-active'));
      if (!option) return;
      const count = clampQuantity(quantity?.value || 1);
      const cents = Number(option.dataset.gxPriceRaw || 0) * count;
      const amount = count === 1 ? option.dataset.gxPrice : option.dataset.gxPrice.replace(/\d[\d.,]*/, amountFormatter.format(cents / 100));
      setPrice(buttonPrice, amount);
      setPrice(stickyPrice, amount.startsWith('€') ? `${amount.slice(1).trim()} €` : amount);
    };
    $$('[data-gx-quantity-change]', root).forEach((control) => control.addEventListener('click', () => {
      if (!quantity) return;
      quantity.value = String(clampQuantity(Number(quantity.value || 1) + Number(control.dataset.gxQuantityChange)));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    quantity?.addEventListener('input', updatePrices);
    quantity?.addEventListener('change', () => { quantity.value = String(clampQuantity(quantity.value)); updatePrices(); });
    const updateStickyOption = (option) => {
      const packCount = Number(option.dataset.gxPackCount || 0);
      const giftCount = Number(option.dataset.gxGiftCount || 0);
      const packLabel = packCount > 0 ? productText(productCopy.packWorlds, packCount) : ($('strong', option)?.textContent.trim() || option.textContent.trim());
      if (stickyPack) stickyPack.textContent = `${packLabel}${giftCount > 0 ? ` · ${String(productCopy.stickyGifts || ui.stickyGifts).replace('__COUNT__', giftCount)}` : ''}`;
      if (stickyMobilePack) stickyMobilePack.textContent = packCount > 0 && productCopy.stickyPackShort ? productText(productCopy.stickyPackShort, packCount) : packLabel;
      if (stickyDiscounts.length) {
        const price = Number(option.dataset.gxPriceRaw || 0);
        const compare = Number(option.dataset.gxCompareRaw || 0);
        const discount = compare > price && compare > 0 ? Math.round((1 - price / compare) * 100) : 0;
        stickyDiscounts.forEach((badge) => {
          badge.textContent = discount ? `-${discount}%` : '';
          badge.hidden = discount === 0;
        });
      }
      const available = option.dataset.gxAvailable === 'true';
      if (stickyAdd) stickyAdd.disabled = !available;
      if (stickyAddLabel) stickyAddLabel.textContent = available ? productCopy.addToCart : productCopy.soldOut;
      if (stickyMobileAddLabel) stickyMobileAddLabel.textContent = available ? productCopy.addToCart : productCopy.soldOut;
    };
    const selectVariant = (id, userPick = '') => {
      const option = options.find((item) => item.dataset.gxVariant === String(id));
      if (!option) return;
      options.forEach((item) => {
        const active = item === option;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-checked', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      if (input) {
        input.value = String(id);
        input.setAttribute('value', String(id));
      }
      updatePrices();
      if (stickySelect) stickySelect.value = id;
      updateStickyOption(option);
      if (gifts) {
        const giftCount = Number(option.dataset.gxGiftCount || 0);
        gifts.hidden = giftCount === 0;
        const giftExtra = $('[data-gx-gift-extra]', gifts);
        if (giftExtra) giftExtra.hidden = giftCount < 3;
        if (giftCount > 0 && giftsHeading) {
          giftsHeading.textContent = productText(productCopy.giftsFree, option.dataset.gxPackCount).replace('__GIFTS__', giftCount);
        }
      }
      if (option.dataset.gxPackImage && userPick) {
        const productRoot = option.closest('[data-gx-product]') || document;
        const packGallery = $('[data-gx-gallery]', productRoot);
        packGallery?._gxShowPack?.(option.dataset.gxPackImage, $('strong', option)?.textContent.trim());
        const hero = $('.gx-gallery__main', packGallery || productRoot);
        if (hero && userPick === 'scroll') {
          const rect = hero.getBoundingClientRect();
          const headerBottom = $('.galix-header')?.getBoundingClientRect().bottom || 0;
          if (rect.top < headerBottom || rect.bottom > window.innerHeight) {
            window.scrollTo({ top: window.scrollY + rect.top - headerBottom - 12, behavior: reducedMotion ? 'auto' : 'smooth' });
          }
        }
      }
      const ship = $('[data-gx-ship]', option.closest('[data-gx-product]') || document);
      if (ship) ship.textContent = option.dataset.gxFreeShip === 'true' ? ship.dataset.shipFree : ship.dataset.shipDefault;
      const available = option.dataset.gxAvailable === 'true';
      if (stock) stock.hidden = !available;
      if (add) {
        add.disabled = !available;
        const label = $('span', add);
        if (label) label.textContent = available ? productCopy.addToCart : productCopy.soldOut;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      history.replaceState({}, '', url);
    };
    options.forEach((option) => option.addEventListener('click', () => selectVariant(option.dataset.gxVariant, 'scroll')));
    options.forEach((option, optionIndex) => option.addEventListener('keydown', (event) => {
      if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let nextIndex = optionIndex;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (optionIndex + 1) % options.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (optionIndex - 1 + options.length) % options.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = options.length - 1;
      selectVariant(options[nextIndex].dataset.gxVariant, 'photo');
      options[nextIndex].focus();
    }));
    const initialOption = options.find((option) => option.classList.contains('is-active'));
    if (initialOption) updateStickyOption(initialOption);
    stickySelect?.addEventListener('change', () => selectVariant(stickySelect.value, 'photo'));
    stickyAdd?.addEventListener('click', () => {
      selectVariant(stickySelect?.value || input?.value);
      $('[data-gx-product-form]', root)?.requestSubmit();
    });
  }

  function initCompare(scope = document) {
    $$('[data-gx-compare]', scope).forEach((stage) => {
      if (stage.dataset.ready) return;
      stage.dataset.ready = 'true';
      const range = $('[data-gx-compare-range]', stage);
      if (!range) return;
      const render = () => stage.style.setProperty('--gx-split', range.value + '%');
      range.addEventListener('input', render);
      render();
    });
  }

  function initReviewsAnchor(scope = document) {
    $$('[data-gx-reviews-anchor]', scope).forEach((anchor) => {
      if (anchor.dataset.ready) return;
      anchor.dataset.ready = 'true';
      const goToReviews = (event) => {
        event?.preventDefault();
        const reviews = $('#experiencias');
        if (!reviews) return;
        // La sección entra con animación de aparición: se muestra ya para no llegar a un hueco vacío que luego salta.
        [reviews, ...$$('[data-reveal]', reviews)].forEach((item) => {
          if (!item.matches('[data-reveal]')) return;
          item.style.transition = 'none';
          item.classList.add('is-visible');
          item.dataset.revealReady = 'true';
          requestAnimationFrame(() => { item.style.transition = ''; });
        });
        // Destino exacto bajo el header fijo (en móvil cambia de alto al hacer scroll).
        const header = $('[data-galix-header] .galix-header__shell') || $('[data-galix-header]');
        const headerSpace = header ? Math.max(0, Math.min(header.getBoundingClientRect().bottom, 140)) : 0;
        const top = reviews.getBoundingClientRect().top + window.scrollY - headerSpace - 12;
        window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion ? 'auto' : 'smooth' });
        history.replaceState({}, '', '#experiencias');
      };
      anchor.addEventListener('click', goToReviews);
      anchor.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        goToReviews(event);
      });
    });
  }

  function initReviewsMedia(scope = document) {
    $$('[data-gx-reviews-media]', scope).forEach((root) => {
      if (root.dataset.ready) return;
      const track = $('[data-gx-reviews-track]', root);
      const previous = $('[data-gx-reviews-prev]', root);
      const next = $('[data-gx-reviews-next]', root);
      if (!track || !previous || !next) return;
      root.dataset.ready = 'true';

      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= maxScroll - 2 || maxScroll <= 2;
      };
      const move = (direction) => {
        const card = $('.gx-reviews__media-card', track);
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * .8;
        track.scrollBy({ left: direction * distance, behavior: reducedMotion ? 'auto' : 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      const observer = new ResizeObserver(update);
      observer.observe(track);
      root._gxReviewsObserver = observer;
      requestAnimationFrame(update);
    });
  }

  function initSticky(scope = document) {
    const sticky = $('[data-gx-sticky-atc]', scope);
    const form = $('[data-gx-product-form]', scope);
    if (!sticky || !form || sticky.dataset.ready) return;
    sticky.dataset.ready = 'true';
    const controller = new AbortController();
    const previewResize = new ResizeObserver(updatePreviewOffset);
    let previewAttributes;
    let previewMount;
    let previewWrapper;
    function updatePreviewOffset() {
      const wrapper = previewWrapper;
      const rect = wrapper?.getBoundingClientRect();
      const style = wrapper ? getComputedStyle(wrapper) : null;
      const height = rect && style?.display !== 'none' && style?.visibility !== 'hidden' && rect.bottom >= window.innerHeight - 2
        ? Math.ceil(rect.height) : 0;
      sticky.style.setProperty('--gx-sticky-preview-inset', `${height}px`);
    }
    const attachPreview = () => {
      const wrapper = document.getElementById('PBarNextFrameWrapper');
      if (!wrapper || wrapper === previewWrapper) return;
      previewWrapper = wrapper;
      previewResize.observe(wrapper);
      previewAttributes = new MutationObserver(updatePreviewOffset);
      previewAttributes.observe(wrapper, { attributes: true, attributeFilter: ['class', 'style'] });
      previewMount?.disconnect();
      updatePreviewOffset();
    };
    attachPreview();
    if (!previewWrapper) {
      previewMount = new MutationObserver(attachPreview);
      previewMount.observe(document.body, { childList: true, subtree: true });
    }
    const render = () => {
      const formRect = form.getBoundingClientRect();
      const footer = $('.galix-footer');
      const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      const visible = formRect.bottom < 0 && footerTop > window.innerHeight * .75;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      sticky.inert = !visible;
    };
    render();
    window.addEventListener('scroll', () => requestAnimationFrame(render), { passive: true, signal: controller.signal });
    window.addEventListener('resize', () => { render(); updatePreviewOffset(); }, { passive: true, signal: controller.signal });
    sticky._gxStickyCleanup = () => {
      controller.abort();
      previewResize.disconnect();
      previewAttributes?.disconnect();
      previewMount?.disconnect();
    };
  }

  function initProductAccordions(scope = document) {
    const root = scope.matches?.('.gx-product-accordions') ? scope : $('.gx-product-accordions', scope);
    if (!root || root._gxAccordionsAbort) return;
    const controller = new AbortController();
    const { signal } = controller;
    const items = $$('details', root);
    const states = new Map(items.map((detail) => [detail, { targetOpen: detail.open, animation: null }]));
    root._gxAccordionsAbort = controller;
    let anchorFrame = 0;

    const setOpen = (detail, shouldOpen) => {
      const state = states.get(detail);
      if (!state || state.targetOpen === shouldOpen) return;
      const startHeight = detail.getBoundingClientRect().height;
      if (state.animation) {
        state.animation.onfinish = null;
        state.animation.cancel();
      }
      state.targetOpen = shouldOpen;
      detail.open = true;
      const border = parseFloat(getComputedStyle(detail).borderBottomWidth) || 0;
      const endHeight = shouldOpen
        ? detail.getBoundingClientRect().height
        : $('summary', detail).getBoundingClientRect().height + border;
      if (reducedMotion || !detail.animate) {
        detail.open = shouldOpen;
        detail.style.overflow = '';
        state.animation = null;
        return;
      }
      detail.style.overflow = 'hidden';
      const animation = detail.animate(
        [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
        { duration: 320, easing: 'cubic-bezier(.22, 1, .36, 1)' }
      );
      state.animation = animation;
      animation.onfinish = () => {
        if (state.animation !== animation) return;
        detail.open = state.targetOpen;
        detail.style.overflow = '';
        state.animation = null;
      };
    };

    const keepClickedRow = (detail, top, closingAbove) => {
      cancelAnimationFrame(anchorFrame);
      const settle = () => {
        const shift = detail.getBoundingClientRect().top - top;
        if (Math.abs(shift) > .5) window.scrollTo({ top: window.scrollY + shift, behavior: 'instant' });
        if (closingAbove.some((item) => states.get(item).animation?.playState === 'running')) {
          anchorFrame = requestAnimationFrame(settle);
        } else anchorFrame = 0;
      };
      settle();
    };

    items.forEach((detail, index) => {
      $('summary', detail)?.addEventListener('click', (event) => {
        event.preventDefault();
        const shouldOpen = !states.get(detail).targetOpen;
        const top = detail.getBoundingClientRect().top;
        const closingAbove = shouldOpen
          ? items.slice(0, index).filter((item) => states.get(item).targetOpen)
          : [];
        if (shouldOpen) items.forEach((item) => { if (item !== detail) setOpen(item, false); });
        setOpen(detail, shouldOpen);
        if (closingAbove.length) keepClickedRow(detail, top, closingAbove);
      }, { signal });
    });
    signal.addEventListener('abort', () => {
      cancelAnimationFrame(anchorFrame);
      states.forEach((state) => state.animation?.cancel());
      items.forEach((detail) => { detail.style.overflow = ''; });
      delete root._gxAccordionsAbort;
    }, { once: true });
  }

  function initFaqImageZoom(scope = document) {
    const images = $$('.galix-faq-accordion details > div img', scope);
    if (!images.length) return;
    let dialog = $('[data-gx-faq-image-lightbox]');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'gx-faq-image-lightbox';
      dialog.setAttribute('aria-label', ui.zoomDialog);
      dialog.setAttribute('data-gx-faq-image-lightbox', '');
      dialog.innerHTML = '<button class="gx-faq-image-lightbox__close" type="button" aria-label="">×</button><img class="gx-faq-image-lightbox__image" alt="">';
      $('.gx-faq-image-lightbox__close', dialog).setAttribute('aria-label', ui.zoomClose);
      document.body.append(dialog);
      const image = $('.gx-faq-image-lightbox__image', dialog);
      const close = () => { if (dialog.open) dialog.close(); };
      $('.gx-faq-image-lightbox__close', dialog).addEventListener('click', close);
      dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
      dialog._gxFaqImage = image;
    }
    images.forEach((image) => {
      if (image.dataset.gxZoomReady) return;
      image.dataset.gxZoomReady = 'true';
      image.tabIndex = 0;
      image.setAttribute('role', 'button');
      image.setAttribute('aria-haspopup', 'dialog');
      image.setAttribute('aria-label', `${ui.zoomOpen}${image.alt ? `: ${image.alt}` : ''}`);
      const open = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const fullImage = dialog._gxFaqImage;
        fullImage.src = image.currentSrc || image.src;
        fullImage.alt = image.alt;
        dialog.showModal();
        $('.gx-faq-image-lightbox__close', dialog).focus();
        dialog._gxFaqOpener = image;
      };
      image.addEventListener('click', open);
      image.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        open(event);
      });
    });
    if (!dialog.dataset.focusReturnReady) {
      dialog.dataset.focusReturnReady = 'true';
      dialog.addEventListener('close', () => {
        if (dialog._gxFaqOpener?.isConnected) dialog._gxFaqOpener.focus({ preventScroll: true });
        dialog._gxFaqOpener = null;
      });
    }
  }

  function initFaq(scope = document) {
    const root = $('[data-gx-faq]', scope);
    if (root && !root.dataset.ready) {
      root.dataset.ready = 'true';
      const items = $$('[data-gx-faq-item]', root);
      const buttons = $$('[data-gx-faq-filter]', root);
      const states = new Map(items.map((detail) => [detail, { targetOpen: detail.open, animation: null }]));
      const setOpen = (detail, shouldOpen) => {
        const state = states.get(detail);
        if (state.targetOpen === shouldOpen) return;
        const startHeight = detail.getBoundingClientRect().height;
        if (state.animation) {
          state.animation.onfinish = null;
          state.animation.cancel();
        }
        state.targetOpen = shouldOpen;
        detail.open = true;
        const border = parseFloat(getComputedStyle(detail).borderBottomWidth) || 0;
        const endHeight = shouldOpen
          ? detail.getBoundingClientRect().height
          : $('summary', detail).getBoundingClientRect().height + border;
        if (reducedMotion || !detail.animate) {
          detail.open = shouldOpen;
          detail.style.overflow = '';
          state.animation = null;
          return;
        }
        detail.style.overflow = 'hidden';
        const animation = detail.animate([
          { height: `${startHeight}px` },
          { height: `${endHeight}px` }
        ], { duration: 320, easing: 'cubic-bezier(.22, 1, .36, 1)' });
        state.animation = animation;
        animation.onfinish = () => {
          if (state.animation !== animation) return;
          detail.open = state.targetOpen;
          detail.style.overflow = '';
          state.animation = null;
        };
      };
      let anchorFrame = 0;
      const keepClickedRow = (detail, top, closingAbove) => {
        cancelAnimationFrame(anchorFrame);
        const settle = () => {
          const shift = detail.getBoundingClientRect().top - top;
          if (Math.abs(shift) > .5) window.scrollTo({ top: window.scrollY + shift, behavior: 'instant' });
          if (closingAbove.some((item) => states.get(item).animation?.playState === 'running')) {
            anchorFrame = requestAnimationFrame(settle);
          } else {
            anchorFrame = 0;
          }
        };
        settle();
      };
      const activate = (button) => {
        buttons.forEach((item) => item.classList.toggle('is-active', item === button));
        const category = button.dataset.gxFaqFilter;
        items.forEach((item) => { item.hidden = category !== 'all' && item.dataset.gxFaqItem !== category; });
      };
      buttons.forEach((button) => button.addEventListener('click', () => activate(button)));
      items.forEach((detail, index) => {
        const summary = $('summary', detail);
        if (!summary) return;
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          const shouldOpen = !states.get(detail).targetOpen;
          const top = detail.getBoundingClientRect().top;
          const closingAbove = shouldOpen
            ? items.slice(0, index).filter((item) => states.get(item).targetOpen)
            : [];
          if (shouldOpen) items.forEach((item) => { if (item !== detail) setOpen(item, false); });
          setOpen(detail, shouldOpen);
          if (closingAbove.length) keepClickedRow(detail, top, closingAbove);
        });
      });
      const active = buttons.find((button) => button.classList.contains('is-active')) || buttons[0];
      if (active) activate(active);
    }
    const page = $('[data-gx-faq-page]', scope);
    if (!page || page.dataset.ready) return;
    page.dataset.ready = 'true';
    const items = $$('[data-gx-page-faq-list] details', page);
    const empty = $('[data-gx-faq-empty]', page);
    const search = $('[data-gx-faq-search]', page);
    let category = 'all';
    const filter = () => {
      const query = (search?.value || '').trim().toLocaleLowerCase('es');
      let visible = 0;
      items.forEach((item) => {
        const matchesCategory = category === 'all'
          ? item.dataset.category === 'all' || item.dataset.category === 'function'
          : item.dataset.category === category;
        const matchesQuery = !query || (item.textContent || '').toLocaleLowerCase('es').includes(query);
        item.hidden = !(matchesCategory && matchesQuery);
        if (!item.hidden) visible += 1;
      });
      if (empty) empty.hidden = visible > 0;
    };
    $$('[data-gx-page-category]', page).forEach((button) => button.addEventListener('click', () => {
      category = button.dataset.gxPageCategory;
      $$('[data-gx-page-category]', page).forEach((item) => item.classList.toggle('is-active', item === button));
      filter();
    }));
    search?.addEventListener('input', filter);
    items.forEach((detail) => detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      items.forEach((item) => { if (item !== detail) item.open = false; });
    }));
    filter();
  }

  function initDragScroll(scope = document) {
    $$('[data-gx-drag-scroll]', scope).forEach((rail) => {
      if (rail.dataset.ready) return;
      rail.dataset.ready = 'true';
      let down = false;
      let start = 0;
      let scroll = 0;
      rail.addEventListener('pointerdown', (event) => {
        if (event.target.closest('button,a,input,select,textarea')) return;
        if (event.pointerType !== 'mouse') return;
        event.preventDefault();
        down = true; start = event.clientX; scroll = rail.scrollLeft; rail.setPointerCapture(event.pointerId);
      });
      rail.addEventListener('pointermove', (event) => { if (down) rail.scrollLeft = scroll - (event.clientX - start); });
      rail.addEventListener('pointerup', () => { down = false; });
      rail.addEventListener('pointercancel', () => { down = false; });
    });
  }

  function initProductWorlds(scope = document) {
    $$('[data-gx-worlds]', scope).forEach((section) => {
      if (section.dataset.gxWorldsReady) return;
      section.dataset.gxWorldsReady = 'true';
      const cards = $$('[data-gx-world-card]', section);
      const title = $('[data-gx-world-title]', section);
      const thumb = $('[data-gx-world-thumb]', section);
      const select = (index, focus = false, scrollToCard = true) => {
        const selected = cards[index];
        if (!selected) return;
        cards.forEach((card, cardIndex) => {
          const active = cardIndex === index;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-pressed', String(active));
          card.tabIndex = active ? 0 : -1;
        });
        if (title) title.textContent = selected.dataset.title || '';
        if (thumb) {
          thumb.src = selected.dataset.image || selected.querySelector('img')?.src || '';
          thumb.alt = selected.dataset.title ? ui.world.replace('__NAME__', selected.dataset.title) : '';
        }
        if (scrollToCard) selected.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        if (focus) selected.focus({ preventScroll: true });
      };
      cards.forEach((card, index) => {
        card.addEventListener('click', () => select(index));
        card.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % cards.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + cards.length) % cards.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = cards.length - 1;
          else return;
          event.preventDefault();
          select(next, true);
        });
      });
      select(Math.max(0, cards.findIndex((card) => card.classList.contains('is-active'))), false, false);
    });
  }

  function initHowMotion(scope = document) {
    $$('[data-gx-how-scroll]', scope).forEach((section) => {
      if (section.dataset.gxHowReady) return;
      const steps = $$('[data-gx-how-step]', section);
      if (!steps.length) return;
      section.dataset.gxHowReady = 'true';

      const setStep = (nextIndex) => {
        const index = Math.max(0, Math.min(steps.length - 1, nextIndex));
        section.dataset.gxHowState = String(index + 1);
        steps.forEach((step, stepIndex) => {
          const active = stepIndex === index;
          step.classList.toggle('is-active', active);
          if (active) step.setAttribute('aria-current', 'step');
          else step.removeAttribute('aria-current');
        });
      };

      if (reducedMotion) {
        section.dataset.gxHowMotion = 'reduced';
        setStep(0);
        return;
      }

      const controller = new AbortController();
      section._gxHowAbort = controller;
      let queued = false;
      const render = () => {
        queued = false;
        const rect = section.getBoundingClientRect();
        const travel = Math.max(1, rect.height + window.innerHeight * .36);
        const progress = Math.max(0, Math.min(1, (window.innerHeight * .82 - rect.top) / travel));
        const eased = progress * progress * (3 - 2 * progress);
        const index = Math.min(steps.length - 1, Math.floor(progress * steps.length));
        const wave = Math.sin(eased * Math.PI);
        section.style.setProperty('--gx-how-image-y', ((.5 - eased) * 16).toFixed(2) + 'px');
        section.style.setProperty('--gx-how-image-scale', (1.015 + wave * .035).toFixed(4));
        section.style.setProperty('--gx-how-image-rotate', ((eased - .5) * 1.15).toFixed(3) + 'deg');
        setStep(index);
      };
      const requestRender = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(render);
      };
      window.addEventListener('scroll', requestRender, { passive: true, signal: controller.signal });
      window.addEventListener('resize', requestRender, { passive: true, signal: controller.signal });
      render();
    });
  }

  // EUR siempre «54,95 €» (en todos los idiomas); otras monedas como las pinta Shopify («$59.99», «£49.99»).
  const money = (cents, currency = 'EUR') => new Intl.NumberFormat(currency === 'EUR' ? 'es-ES' : 'en-US', { style: 'currency', currency }).format(cents / 100);
  const cartCopy = (key) => $('[data-gx-cart-copy-errors]', $('[data-gx-cart]'))?.dataset[key] || '';
  let cartOpener = null;
  let cartCloseTimer = 0;

  // Rapi añade los regalos como líneas a 0 € (__rapi_offer sin "main":true); el tema ya los muestra aparte.
  const GIFT_HANDLES = ['light', 'guide', 'slides'];
  const isRapiGift = (item) => {
    if (Number(item.final_line_price) !== 0) return false;
    if (GIFT_HANDLES.includes(item.handle)) return true;
    const offer = String((item.properties || {}).__rapi_offer || '');
    return offer !== '' && !offer.includes('"main":true');
  };
  // Regalos del pack como productos a 0 € para que lleguen al checkout y al pedido (sin app):
  // pack de 12 o más → luz nocturna + guía; pack de 20 → además las 4 fichas. Uno de cada por carrito.
  let giftSyncRunning = false;
  let giftSyncAttempts = 0;
  const giftUnavailable = new Set();
  const giftVariantIds = () => Object.fromEntries(String($('[data-gx-cart]')?.dataset.gxGiftVariants || '').split(',').map((pair) => pair.split(':')).filter(([key, id]) => key && Number(id) > 0));
  const wantedGifts = (cart) => {
    const maxPack = Math.max(0, ...(cart.items || []).filter((item) => item.handle === 'galix').map((item) => Number((item.variant_title || '').match(/^\s*(\d+)/)?.[1] || 0)));
    const wanted = { light: 0, guide: 0, slides: 0 };
    if (maxPack > 3) { wanted.light = 1; wanted.guide = 1; }
    if (maxPack >= 20) wanted.slides = 1;
    return wanted;
  };
  const syncGifts = async (cart) => {
    if (giftSyncRunning || !cart) return false;
    const ids = giftVariantIds();
    const wanted = wantedGifts(cart);
    const updates = {};
    Object.entries(wanted).forEach(([key, qty]) => {
      const id = ids[key];
      if (!id || (qty > 0 && giftUnavailable.has(String(id)))) return;
      const current = (cart.items || []).filter((item) => String(item.variant_id) === String(id)).reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
      if (current !== qty) updates[id] = qty;
    });
    if (!Object.keys(updates).length) return false;
    if (giftSyncAttempts >= 12) return false; // corta cualquier bucle si la tienda rechaza los cambios
    giftSyncAttempts += 1;
    giftSyncRunning = true;
    const post = (body) => fetch(localePath('/cart/update.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: body }) });
    try {
      let response = await post(updates);
      let updated = response.ok ? await response.json() : null;
      if (!updated) {
        // Algún regalo no está disponible en este mercado: se aplican uno a uno y se omiten los que fallen.
        for (const [id, qty] of Object.entries(updates)) {
          const single = await post({ [id]: qty });
          if (single.ok) updated = await single.json(); else if (qty > 0) giftUnavailable.add(String(id));
        }
        if (!updated) {
          const fresh = await fetch(localePath('/cart.js'), { headers: { Accept: 'application/json' } });
          updated = fresh.ok ? await fresh.json() : null;
        }
        if (!updated) return false;
      }
      giftSyncRunning = false;
      renderCart(updated);
      document.dispatchEvent(new CustomEvent('galix:gifts-synced', { detail: updates }));
      return true;
    } catch (_) {
      return false;
    } finally {
      giftSyncRunning = false;
    }
  };
  function renderCart(rawCart) {
    syncGifts(rawCart);
    const visibleItems = (rawCart.items || []).filter((item) => !isRapiGift(item));
    const cart = { ...rawCart, items: visibleItems, item_count: visibleItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0) };
    const cartRoot = $('[data-gx-cart]');
    const copy = $('[data-gx-cart-copy]', cartRoot)?.dataset || {};
    const fill = (template, value) => String(template || '').replace('__COUNT__', value).replace('__AMOUNT__', value);
    const isEmpty = cart.item_count === 0;
    const compareByVariant = Object.fromEntries((cartRoot?.dataset.gxVariantCompares || '').split(',').filter(Boolean).map((pair) => pair.split(':')));
    const beforePrice = (item) => Math.max(Number(item.original_line_price) || 0, (Number(compareByVariant[item.variant_id]) || 0) * (Number(item.quantity) || 1));
    $$('[data-gx-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    $$('[data-gx-header-cart-count]').forEach((node) => { node.textContent = cart.item_count; node.hidden = cart.item_count === 0; });
    $$('[data-cart-open]').forEach((button) => { button.setAttribute('aria-label', `${copy.cart || button.textContent.trim()}${cart.item_count ? `, ${cart.item_count}` : ''}`); });
    const body = $('[data-gx-cart-body]');
    const total = $('[data-gx-cart-total]');
    const savings = $('[data-gx-cart-savings]');
    const subtotal = $('[data-gx-cart-subtotal]');
    if (cartRoot) {
      cartRoot.classList.toggle('is-empty', isEmpty);
      cartRoot.querySelector('[data-gx-cart-footer]')?.toggleAttribute('hidden', isEmpty);
    }
    if (subtotal) subtotal.hidden = isEmpty;
    if (total) total.textContent = money(cart.total_price, cart.currency || 'EUR');
    const saved = Math.max(0, cart.items.reduce((sum, item) => sum + Math.max(0, beforePrice(item) - item.final_line_price), 0));
    if (savings) { savings.hidden = saved === 0; savings.textContent = saved ? fill(copy.saving, money(saved, cart.currency || 'EUR')) : ''; }
    $$('[data-gx-cart-checkout]').forEach((checkout) => {
      checkout.classList.toggle('is-disabled', isEmpty);
      checkout.setAttribute('aria-disabled', isEmpty ? 'true' : 'false');
      checkout.tabIndex = isEmpty ? -1 : 0;
    });
    if (!body) return;
    body.textContent = '';
    if (!cart.items.length) {
      const empty = document.createElement('div');
      empty.className = 'gx-cart__empty';
      const star = document.createElement('span'); star.setAttribute('aria-hidden', 'true'); star.textContent = '✦';
      const title = document.createElement('h3'); title.textContent = copy.empty || '';
      const emptyCopy = document.createElement('p'); emptyCopy.textContent = copy.emptyHelp || '';
      const link = document.createElement('a'); link.className = 'gx-primary'; link.href = localePath('/products/galix'); link.textContent = copy.discover || '';
      empty.append(star, title, emptyCopy, link); body.append(empty); return;
    }
    cart.items.forEach((item) => {
      const article = document.createElement('article'); article.className = 'gx-cart-item'; article.dataset.key = item.key;
      const productImage = cartRoot?.dataset.gxProductImage || item.image;
      if (productImage) { const imageWrap = document.createElement('span'); imageWrap.className = 'gx-cart-item__image'; const image = new Image(); image.src = productImage; image.alt = copy.product || ''; imageWrap.append(image); article.append(imageWrap); }
      const info = document.createElement('div'); info.className = 'gx-cart-item__info';
      const title = document.createElement('h3'); title.textContent = copy.product || '';
      const worlds = Number((item.variant_title || '').match(/^\s*(\d+)/)?.[1] || 0);
      const variant = document.createElement('p'); variant.textContent = worlds ? fill(copy.pack, worlds) : (item.variant_title || '');
      const prices = document.createElement('div'); prices.className = 'gx-cart-item__prices';
      const before = beforePrice(item);
      if (before > item.final_line_price) { const compare = document.createElement('del'); compare.textContent = fill(copy.before, money(before, cart.currency || 'EUR')); prices.append(compare); }
      const price = document.createElement('strong'); price.textContent = money(item.final_line_price, cart.currency || 'EUR'); prices.append(price);
      const quantity = document.createElement('div'); quantity.className = 'gx-quantity';
      const minus = document.createElement('button'); minus.type = 'button'; minus.dataset.gxQty = '-1'; minus.setAttribute('aria-label', copy.minus || ''); minus.textContent = '−';
      const value = document.createElement('span'); value.textContent = item.quantity;
      const plus = document.createElement('button'); plus.type = 'button'; plus.dataset.gxQty = '1'; plus.setAttribute('aria-label', copy.plus || ''); plus.textContent = '+';
      quantity.append(minus, value, plus);
      const aside = document.createElement('div'); aside.className = 'gx-cart-item__aside';
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'gx-cart-item__remove'; remove.dataset.gxRemove = ''; remove.setAttribute('aria-label', copy.remove || ''); remove.innerHTML = '<svg viewBox="0 0 19.8333 19.8333" aria-hidden="true"><path d="M7.16667 19.0833H12.6667C17.25 19.0833 19.0833 17.25 19.0833 12.6667V7.16667C19.0833 2.58333 17.25.75 12.6667.75H7.16667C2.58333.75.75 2.58333.75 7.16667V12.6667C.75 17.25 2.58333 19.0833 7.16667 19.0833Z"/><path d="M15.325 7.2125C13.3238 7.01162 11.3138 6.91066 9.3025 6.91C8.11083 6.91 6.91917 6.97417 5.73667 7.09333L4.50833 7.2125M7.8175 6.6075L7.94583 5.81917C8.0375 5.25083 8.11083 4.82 9.12833 4.82H10.705C11.7225 4.82 11.7958 5.26917 11.8875 5.81917L12.0158 6.59833M14.0325 7.28583L13.6383 13.3358C13.5742 14.28 13.5192 15.0133 11.8417 15.0133H7.9825C6.305 15.0133 6.25 14.28 6.18583 13.3358L5.79167 7.28583"/></svg>';
      aside.append(prices, remove);
      if (before > item.final_line_price) { const saving = document.createElement('small'); saving.className = 'gx-cart-item__saving'; saving.textContent = fill(copy.saving, money(before - item.final_line_price, cart.currency || 'EUR')); aside.append(saving); }
      info.append(title, variant, quantity);
      article.append(info, aside); body.append(article);
    });
    const giftRows = [];
    const maxPack = Math.max(0, ...cart.items.map((item) => Number((item.variant_title || '').match(/^\s*(\d+)/)?.[1] || 0)));
    if (maxPack > 3) {
      giftRows.push(
        { key: 'guide', name: copy.guide || '', image: 'guide' },
        { key: 'light', name: copy.light || '', image: 'light' }
      );
      // El pack de 20 mundos suma 4 fichas de regalo.
      if (maxPack >= 20) giftRows.push({ key: 'slides', name: copy.extraSlides || '', image: 'slides' });
    }
    if (giftRows.length) {
      const gifts = document.createElement('section'); gifts.className = 'gx-cart-gifts';
      const heading = document.createElement('h3'); heading.textContent = fill(copy.gifts, maxPack >= 20 ? 4 : giftRows.length); gifts.append(heading);
      giftRows.forEach((gift) => {
        const row = document.createElement('div'); row.className = 'gx-cart-gift';
        const image = new Image(); image.src = gift.image === 'guide' ? cartRoot?.dataset.gxGiftGuideImage : gift.image === 'slides' ? cartRoot?.dataset.gxGiftSlidesImage : cartRoot?.dataset.gxGiftLightImage; image.alt = ''; image.width = 96; image.height = 96;
        const name = document.createElement('strong'); name.textContent = gift.name;
        const meta = document.createElement('small'); meta.textContent = copy.included || '';
        const icon = document.createElement('span'); icon.className = 'gx-cart-gift__icon'; icon.setAttribute('aria-hidden', 'true'); icon.innerHTML = '<svg viewBox="0 0 32 32" focusable="false"><path d="M4 13h24v4H4zM6 17h20v12H6zM16 13v16M3 9h26v4H3zM16 9c-1-4-7-5-7-1 0 2 3 2 7 2m0-1c1-4 7-5 7-1 0 2-3 2-7 2"/></svg>';
        row.append(image, name, meta, icon); gifts.append(row);
      });
      body.append(gifts);
    }
    const upsellId = cartRoot?.dataset.gxUpsellId;
    const upsellTitle = cartRoot?.dataset.gxUpsellTitle || '';
    const upsellWorlds = Number(upsellTitle.match(/^\s*(\d+)/)?.[1] || 20);
    const upsellAddedItem = cart.items.find((item) => String(item.variant_id) === String(upsellId));
    const upgradeItem = cart.items.find((item) => String(item.variant_id) !== String(upsellId) && /^\s*(\d+)/.test(item.variant_title || ''));
    const packItem = upgradeItem || upsellAddedItem;
    if (upsellId && packItem) {
      const upsellAdded = Boolean(upsellAddedItem);
      const currentWorlds = Number((packItem.variant_title || '').match(/^\s*(\d+)/)?.[1] || 0);
      const extraWorlds = Math.max(0, upsellWorlds - currentWorlds);
      const upsellPrice = Number(cartRoot.dataset.gxUpsellPrice || 0);
      const currentPrice = Number(packItem.original_price || packItem.price || packItem.final_price || 0);
      const upgradePrice = Math.max(0, upsellPrice - currentPrice) * Number(packItem.quantity || 1);
      const hasDynamicDiscount = Number(cart.total_discount || 0) > 0;
      const upsell = document.createElement('section'); upsell.className = 'gx-cart-upsell';
      const heading = document.createElement('h3'); heading.textContent = copy.upsellHeading || '';
      const lead = document.createElement('p'); lead.className = 'gx-cart-upsell__lead'; lead.textContent = upsellAdded ? (copy.upsellAdded || '') : extraWorlds ? fill(copy.upsellAdd, extraWorlds) : (copy.upsellDiscover || '');
      const card = document.createElement('button'); card.type = 'button'; card.className = `gx-cart-upsell__card${upsellAdded ? ' is-added' : ''}`;
      if (upsellAdded) {
        const sourceVariant = upsellAddedItem.properties?._gx_upsell_from_variant || cartRoot?.dataset.gxUpsellFallbackId;
        if (sourceVariant) { card.dataset.gxUpsellRemove = upsellAddedItem.key; card.dataset.gxUpsellRestoreVariant = sourceVariant; card.dataset.gxUpsellRestoreQuantity = String(upsellAddedItem.quantity); card.dataset.gxUpsellRestoreProperties = upsellAddedItem.properties?._gx_upsell_from_properties || '{}'; }
        else card.disabled = true;
        card.setAttribute('aria-label', fill(sourceVariant ? copy.upsellRemoveAria : copy.upsellAddedAria, sourceVariant ? (Number(cartRoot?.dataset.gxUpsellFallbackWorlds) || currentWorlds) : upsellWorlds));
      }
      else { card.dataset.gxUpsellAdd = upsellId; card.dataset.gxUpsellReplaceKey = upgradeItem.key; card.dataset.gxUpsellReplaceVariant = upgradeItem.variant_id; card.dataset.gxUpsellReplaceProperties = JSON.stringify(upgradeItem.properties || {}); card.dataset.gxUpsellQuantity = upgradeItem.quantity; card.setAttribute('aria-label', fill(copy.upsellChangeAria, upsellWorlds)); }
      const radio = document.createElement('span'); radio.className = 'gx-cart-upsell__radio'; radio.setAttribute('aria-hidden', 'true');
      if (upsellAdded) radio.textContent = '✓';
      const copyWrap = document.createElement('span'); copyWrap.className = 'gx-cart-upsell__copy';
      const title = document.createElement('strong'); title.textContent = fill(copy.packTitle, upsellWorlds);
      const description = document.createElement('small'); description.className = 'gx-cart-upsell__gifts'; description.textContent = copy.giftCount || '';
      const value = document.createElement('em'); value.textContent = copy.giftValue || '';
      copyWrap.append(title, description, value);
      const prices = document.createElement('span'); prices.className = 'gx-cart-upsell__prices';
      const price = document.createElement('strong'); price.textContent = upsellAdded ? (copy.added || '') : hasDynamicDiscount ? (copy.confirming || '') : `+${money(upgradePrice, cart.currency || 'EUR')}`; prices.append(price);
      if (hasDynamicDiscount) { const note = document.createElement('small'); note.textContent = copy.discountActive || ''; prices.append(note); }
      card.append(radio, copyWrap, prices); upsell.append(heading, lead, card); body.append(upsell);
    }
  }

  async function getCart() {
    const response = await fetch(localePath('/cart.js'), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error($('[data-gx-cart-copy]', $('[data-gx-cart]'))?.dataset.errorLoad || '');
    const cart = await response.json(); renderCart(cart); return cart;
  }

  function showCartError(message) {
    const body = $('[data-gx-cart-body]');
    if (!body) return;
    let error = $('[data-gx-cart-error]', body);
    if (!error) {
      error = document.createElement('p');
      error.dataset.gxCartError = '';
      error.setAttribute('role', 'alert');
      error.style.cssText = 'margin:12px;padding:10px 12px;border-radius:8px;background:#fff0f0;color:#9b1c1c;font-size:13px';
      body.prepend(error);
    }
    error.textContent = message;
  }

  function showAddError(form) {
    let error = $('[data-gx-add-error]', form);
    if (!error) {
      error = document.createElement('p');
      error.dataset.gxAddError = '';
      error.setAttribute('role', 'alert');
      error.style.cssText = 'margin-top:8px;color:#9b1c1c;font-size:13px';
      form.append(error);
    }
    error.textContent = cartCopy('errorAdd');
  }

  function openCart(opener) {
    const cart = $('[data-gx-cart]');
    if (!cart) return;
    clearTimeout(cartCloseTimer);
    cartCloseTimer = 0;
    cartOpener = opener || document.activeElement;
    const wasHidden = cart.hidden;
    cart.hidden = false;
    if (wasHidden) cart.getBoundingClientRect();
    cart.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    $('.gx-cart__drawer', cart)?.focus({ preventScroll: true });
    getCart().catch(() => showCartError(cartCopy('errorUpdate')));
  }
  function closeCart() {
    const cart = $('[data-gx-cart]');
    if (!cart || cart.hidden || !cart.classList.contains('is-open')) return;
    cart.classList.remove('is-open');
    const finish = () => {
      cartCloseTimer = 0;
      if (cart.classList.contains('is-open')) return;
      cart.hidden = true;
      document.documentElement.style.overflow = '';
      if (cartOpener instanceof HTMLElement && cartOpener.isConnected) cartOpener.focus({ preventScroll: true });
    };
    const drawer = $('.gx-cart__drawer', cart);
    const duration = drawer ? Math.max(...getComputedStyle(drawer).transitionDuration.split(',').map((value) => {
      const time = parseFloat(value) || 0;
      return value.trim().endsWith('ms') ? time : time * 1000;
    })) : 0;
    if (!duration) finish();
    else cartCloseTimer = setTimeout(finish, duration + 40);
  }

  function initCart(scope = document) {
    const cart = $('[data-gx-cart]', scope);
    if (!cart || cart.dataset.ready) return;
    cart.dataset.ready = 'true';
    // Al cargar cualquier página: si el carrito tiene un pack sin sus regalos (o regalos sobrantes), se corrige.
    if (!cart.classList.contains('is-empty')) {
      fetch(localePath('/cart.js'), { headers: { Accept: 'application/json' } }).then((response) => response.ok ? response.json() : null).then(async (current) => {
        if (!current) return;
        const changed = await syncGifts(current);
        if (changed && document.querySelector('.gx-cart-page')) window.location.reload();
      }).catch(() => {});
    }
    $$('[data-cart-open]', document).forEach((button) => button.addEventListener('click', (event) => { event.preventDefault(); openCart(button); }));
    $$('[data-gx-cart-close]', cart).forEach((button) => button.addEventListener('click', closeCart));
    cart.addEventListener('click', async (event) => {
      const upsellButton = event.target.closest('[data-gx-upsell-add]');
      if (upsellButton) {
        upsellButton.disabled = true;
        try {
          const response = await fetch(localePath('/cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: upsellButton.dataset.gxUpsellAdd, quantity: Number(upsellButton.dataset.gxUpsellQuantity || 1), properties: { _gx_upsell_from_variant: String(upsellButton.dataset.gxUpsellReplaceVariant), _gx_upsell_from_properties: upsellButton.dataset.gxUpsellReplaceProperties || '{}' } }) });
          if (!response.ok) throw new Error();
          const addedItem = await response.json();
          let updatedCart;
          if (upsellButton.dataset.gxUpsellReplaceKey) {
            const removeResponse = await fetch(localePath('/cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: upsellButton.dataset.gxUpsellReplaceKey, quantity: 0 }) });
            if (!removeResponse.ok) {
              if (addedItem?.key) await fetch(localePath('/cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: addedItem.key, quantity: 0 }) });
              throw new Error();
            }
            updatedCart = await removeResponse.json();
          }
          if (updatedCart) renderCart(updatedCart); else await getCart();
        } catch (_) { showCartError(cartCopy('errorChangePack')); }
        finally { if (upsellButton.isConnected) upsellButton.disabled = false; }
        return;
      }
      const removeUpsellButton = event.target.closest('[data-gx-upsell-remove]');
      if (removeUpsellButton) {
        removeUpsellButton.disabled = true;
        removeUpsellButton.classList.add('is-removing');
        removeUpsellButton.setAttribute('aria-label', ui.reverting);
        const upsellSection = removeUpsellButton.closest('.gx-cart-upsell');
        const lead = $('.gx-cart-upsell__lead', upsellSection);
        const status = $('.gx-cart-upsell__prices strong', removeUpsellButton);
        const radio = $('.gx-cart-upsell__radio', removeUpsellButton);
        if (lead) lead.textContent = ui.revertingLead;
        if (status) status.textContent = ui.updating;
        if (radio) radio.textContent = '';
        let restoredItem;
        try {
          let properties = {};
          try { properties = JSON.parse(removeUpsellButton.dataset.gxUpsellRestoreProperties || '{}'); } catch (_) {}
          const restoreResponse = await fetch(localePath('/cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: removeUpsellButton.dataset.gxUpsellRestoreVariant, quantity: Number(removeUpsellButton.dataset.gxUpsellRestoreQuantity || 1), properties }) });
          if (!restoreResponse.ok) throw new Error();
          restoredItem = await restoreResponse.json();
          const removeResponse = await fetch(localePath('/cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: removeUpsellButton.dataset.gxUpsellRemove, quantity: 0 }) });
          if (!removeResponse.ok) {
            if (restoredItem?.key) await fetch(localePath('/cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: restoredItem.key, quantity: 0 }) });
            throw new Error();
          }
          renderCart(await removeResponse.json());
        } catch (_) {
          await getCart().catch(() => showCartError(cartCopy('errorUpdate')));
          showCartError(cartCopy('errorRemovePack'));
        }
        finally { if (removeUpsellButton.isConnected) removeUpsellButton.disabled = false; }
        return;
      }
      const item = event.target.closest('.gx-cart-item');
      if (!item) return;
      const quantityButton = event.target.closest('[data-gx-qty]');
      const removeButton = event.target.closest('[data-gx-remove]');
      if (!quantityButton && !removeButton) return;
      if (item.dataset.updating === 'true') return;
      const current = Number($('.gx-quantity span', item)?.textContent || 1);
      const quantity = removeButton ? 0 : Math.max(0, current + Number(quantityButton.dataset.gxQty));
      item.dataset.updating = 'true';
      item.setAttribute('aria-busy', 'true');
      $$('button', item).forEach((button) => { button.disabled = true; });
      try {
        const response = await fetch(localePath('/cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.dataset.key, quantity }) });
        if (!response.ok) throw new Error();
        renderCart(await response.json());
      } catch (_) { showCartError(cartCopy('errorUpdate')); }
      finally {
        if (item.isConnected) {
          delete item.dataset.updating;
          item.removeAttribute('aria-busy');
          $$('button', item).forEach((button) => { button.disabled = false; });
        }
      }
    });
    document.addEventListener('keydown', (event) => {
      if (!cart.classList.contains('is-open')) return;
      if (event.key === 'Escape') { closeCart(); return; }
      if (event.key !== 'Tab') return;
      const focusable = $$('a[href]:not([tabindex="-1"]),button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', cart).filter((node) => !node.hidden);
      if (!focusable.length) return;
      const first = focusable[0]; const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    if (document.documentElement.dataset.gxCartSubmitReady) return;
    document.documentElement.dataset.gxCartSubmitReady = 'true';
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest?.('[data-gx-product-form], [data-pack-form]');
      if (!form) return;
      event.preventDefault();
      if (form.dataset.gxAdding === 'true') return;
      form.dataset.gxAdding = 'true';
      const button = $('[data-gx-add], button[type="submit"]', form);
      if (button) button.disabled = true;
      try {
        const response = await fetch(localePath('/cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error();
        $('[data-gx-add-error]', form)?.remove();
        openCart(button);
      } catch (_) { showAddError(form); }
      finally { form.dataset.gxAdding = 'false'; if (button) button.disabled = false; }
    });
  }

  function initParallax(scope = document) {
    if (reducedMotion) return;
    const targets = $$('.gx-404>img,.gx-contact-page__background,.gx-faq-hero>img', scope);
    if (!targets.length) return;
    let queued = false;
    const render = () => {
      queued = false;
      targets.forEach((target) => {
        const rect = target.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > innerHeight) return;
        const progress = (innerHeight - rect.top) / (innerHeight + rect.height);
        target.style.setProperty('--gx-parallax', ((progress - .5) * 18).toFixed(2) + 'px');
      });
    };
    addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(render); } }, { passive: true });
    render();
  }

  function initPassword(scope = document) {
    $$('[data-gx-password-toggle]', scope).forEach((toggle) => {
      if (toggle.dataset.ready) return;
      toggle.dataset.ready = 'true';
      toggle.addEventListener('click', () => {
        const input = toggle.closest('.gx-password__field')?.querySelector('[data-gx-password-input]');
        if (!input) return;
        const visible = input.type === 'password';
        input.type = visible ? 'text' : 'password';
        toggle.setAttribute('aria-pressed', visible ? 'true' : 'false');
        toggle.setAttribute('aria-label', visible ? ui.hidePassword : ui.showPassword);
      });
    });
  }

  function initFooter(scope = document) {
    $$('.galix-footer nav a[href^="#"]', scope).forEach((link) => {
      link.href = '/' + link.getAttribute('href');
    });
    $$('.galix-footer__socials', scope).forEach((socials) => {
      socials.hidden = false;
    });
  }

  function init(scope = document) {
    initGallery(scope); initVariants(scope); initCompare(scope); initReviewsAnchor(scope); initReviewsMedia(scope); initSticky(scope); initFaqImageZoom(scope);
    initProductAccordions(scope); initFaq(scope); initProductWorlds(scope); initHowMotion(scope); initDragScroll(scope); initCart(scope); initParallax(scope); initPassword(scope); initFooter(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    $$('[data-gx-gallery]', event.target).forEach((gallery) => gallery._gxGalleryCleanup?.());
    $$('.gx-product-accordions', event.target).forEach((root) => root._gxAccordionsAbort?.abort());
    $$('[data-gx-how-scroll]', event.target).forEach((section) => section._gxHowAbort?.abort());
    $$('[data-gx-reviews-media]', event.target).forEach((section) => section._gxReviewsObserver?.disconnect());
    $$('[data-gx-sticky-atc]', event.target).forEach((sticky) => sticky._gxStickyCleanup?.());
  });
})();
